module.exports = __webpack_public_path__ + "static/media/p3_img1.93434208.png";